/* ----------------- React Native Paper --------------- */
import { Card } from "react-native-paper";

/* ----------------- Types --------------- */
import type { CheckboxStateMap, Section } from "./types";

import Box from "../../Box";
import Button from "../../Button";
import { CardIconHeader } from "../CardIconHeader";
import { FlatCard } from "../FlatCard";
/* ----------------- Child components --------------- */
import CardContent from "./CardContent";

export type StudySessionPerformanceCardProps = {
	title: string;
	subtitle: string;
	sections: Section[];
	handleReviewButtonClick: () => void;
	handleChangeCheckboxStateMap: (key: keyof CheckboxStateMap) => void;
	checkboxStateMap: CheckboxStateMap;
	showReview?: boolean;
};
const StudySessionPerformanceCard = ({
	title,
	subtitle,
	sections,
	handleReviewButtonClick,
	checkboxStateMap,
	handleChangeCheckboxStateMap,
	showReview,
}: StudySessionPerformanceCardProps) => {
	return (
		<FlatCard>
			<Box padding={16} paddingBottom={8}>
				<CardIconHeader
					icon="arm-flex-outline"
					title={title}
					subtitle={subtitle}
				/>
			</Box>
			<CardContent
				sections={sections}
				checkboxStateMap={checkboxStateMap}
				handleCheckboxStateMapChange={(type) => {
					handleChangeCheckboxStateMap(type);
					handleReviewButtonClick();
				}}
				showReview={showReview}
			/>
			{showReview ? (
				<Card.Actions style={{ justifyContent: "flex-end" }}>
					<Button mode="text" onPress={handleReviewButtonClick}>
						Review answers
					</Button>
				</Card.Actions>
			) : null}
		</FlatCard>
	);
};

export { CardContent, StudySessionPerformanceCard };
